export default "__VITE_ASSET__33aca548__"